import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getStoreLabelMap } from '../../helpers';

export const useTransformStoreTypeLabel = (items: RefinementListItem[]) => {
  const { formatMessage } = useIntl();

  const storeLabelMap = getStoreLabelMap(formatMessage);

  return useMemo(() => {
    return items.map((item) => {
      return {
        ...item,
        label: storeLabelMap[item.label] || item.label,
      };
    });
  }, [items, formatMessage]);
};
